module.exports = __webpack_public_path__ + "models/scene2.9ed1339.txt";